import React from "react";

const Notify = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="22"
    fill="none"
    viewBox="0 0 20 22"
    {...props}
  >
    <path
      fill="#FD2C2C"
      fillRule="evenodd"
      d="M9.962 2.334c-3.074 0-5.508 2.814-5.508 6.15v3.565c0 .215-.054.425-.156.604l-1.49 2.62-.01.018c-.171.29-.152.554-.064.744a.655.655 0 00.617.382h13.315c.234 0 .46-.164.586-.43.12-.254.103-.485-.01-.66a1.308 1.308 0 01-.018-.028l-1.583-2.62a1.223 1.223 0 01-.17-.63V8.484c0-1.674-.629-3.275-1.565-4.338-1.065-1.1-2.434-1.812-3.944-1.812zm-7.341 6.15C2.62 3.854 5.96.167 9.962.167c2.022 0 3.814.96 5.168 2.367l.027.029c1.29 1.453 2.147 3.62 2.147 5.921v3.218l1.405 2.326c.62.975.555 2.151.142 3.02-.41.861-1.207 1.536-2.184 1.536H3.35c-1.982 0-3.255-2.494-2.06-4.526l1.33-2.34V8.485zM6.335 20.75c0-.598.41-1.083.916-1.083h5.5c.507 0 .917.485.917 1.083 0 .599-.41 1.084-.916 1.084h-5.5c-.507 0-.917-.485-.917-1.084z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default Notify;
